import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
    DeleteCardRequest,
    HardBlockCardRequest,
    SoftBlockCardRequest,
    deleteCard,
    hardBlockDebitCard,
    reopenCard,
    softBlockCard,
} from '@/react-query/services/block';

import useInvalidateApplePay from '@domain/digital-wallet/hooks/query/use-invalidate-apple-pay';

export const useSoftBlockCard = () => {
    const queryClient = useQueryClient();
    const invalidateApplePay = useInvalidateApplePay();
    return useMutation({
        mutationKey: ['softBlockCard'],
        mutationFn: ({ cardType, cardId }: SoftBlockCardRequest) => softBlockCard(cardType, cardId),
        onSettled: (_, _1, { cardType, cardId }) => {
            invalidateApplePay();
            queryClient.invalidateQueries({ queryKey: ['card', cardType, cardId] });
        },
    });
};

export const useHardBlockCard = () => {
    const queryClient = useQueryClient();
    const invalidateApplePay = useInvalidateApplePay();

    return useMutation({
        mutationKey: ['hardBlockCard'],
        mutationFn: (request: HardBlockCardRequest) => hardBlockDebitCard(request.cardId, request.blockRequest),
        onSuccess: (_, { cardId }) => {
            queryClient.invalidateQueries({ queryKey: ['card', cardId] });
            invalidateApplePay();
            queryClient.invalidateQueries({ queryKey: ['myDebitCards'] });
            queryClient.invalidateQueries({ queryKey: ['relatedDebitCards'] });
        },
    });
};

export const useDeleteCard = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteCard'],
        mutationFn: ({ cardType, cardId }: DeleteCardRequest) => deleteCard(cardType, cardId),
        onSettled: (data, error, { cardType, cardId }) => {
            queryClient.invalidateQueries({ queryKey: ['card', cardType, cardId] });
        },
    });
};

export const useReopenCard = () => {
    const queryClient = useQueryClient();
    const invalidateApplePay = useInvalidateApplePay();

    return useMutation({
        mutationKey: ['reopenCard'],
        mutationFn: ({ cardType, cardId }: SoftBlockCardRequest) => reopenCard(cardType, cardId),
        onSuccess: (_, { cardType, cardId }) => {
            queryClient.invalidateQueries({ queryKey: ['card', cardType, cardId] });
            invalidateApplePay();
        },
    });
};
